import React from 'react'
import PropTypes from 'prop-types'

import Select from '../Select/Select'
import CloseIconSVG from 'component/svgComponents/close'
import Button from 'component/Button'
import Col from 'component/utils/Col'
import Form from 'component/utils/Form'
import Row from 'component/utils/Row'

const FIELDS = ['inInactive']

const IN_INACTIVE_TYPES = [
  { value: 0, label: 'justificationsPa.active' },
  { value: 1, label: 'justificationsPa.inactive' },
  { value: 2, label: 'option.all' },
]

const SideFilterForm = ({
  fields = {},
  setSideFilterVisible = () => {},
  setValueToField = () => {},
  submit,
  translate,
  values,
}) => {
  const inInactiveOptions = IN_INACTIVE_TYPES.map((r) => ({
    ...r,
    label: translate(r.label),
  }))

  return (
    <>
      <div className='bg-filter' onClick={setSideFilterVisible} />
      <div className='right-filter-container'>
        <CloseIconSVG className="right-filter-svg" onClick={setSideFilterVisible} />
        <h3 className='margin-bottom-triple'>
          <strong>{translate('mobile.filter')}</strong>
        </h3>
        <Select
          fill
          label={translate('status')}
          onChange={(option) =>
            setValueToField(fields.inInactive.input.name, option.value)
          }
          options={inInactiveOptions}
          placeholder={translate('status')}
          required
          value={inInactiveOptions.find((r) => r.value === values.inInactive)}
        />
        <Row>
          <Col xs={12} className='margin-bottom margin-top-20 no-padding'>
            <Button
              className='btn btn-primary full-w'
              onClick={() => submit(values)}
              text={translate('filter_button_label')}
            />
          </Col>
        </Row>
      </div>
    </>
  )
}

SideFilterForm.propTypes = {
  fields: PropTypes.object.isRequired,
  setSideFilterVisible: PropTypes.func.isRequired,
  setValueToField: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
}

export default Form({ fields: FIELDS })(SideFilterForm)

export { SideFilterForm }
